import { render, staticRenderFns } from "./MoleculeEditionAssetContentCommentsCreate.vue?vue&type=template&id=60c3cc6e"
import script from "./MoleculeEditionAssetContentCommentsCreate.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionAssetContentCommentsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports